import { render, staticRenderFns } from "./edit-serv-modal.vue?vue&type=template&id=1ce60e9e&"
import script from "./edit-serv-modal.vue?vue&type=script&lang=js&"
export * from "./edit-serv-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports